import React from 'react';
import StocksListFunctional from './components/stocks-list-functional';
import './stocks-list.scss';

const StocksList = () => {
	return <StocksListFunctional />;
};

export default StocksList;
